import React from 'react';

import { BookSortingEnum } from '~/api/book/bookApiTypes';
import { PostLink } from '~/atomic/atom/links/dynamicLinks';
import { getBooks } from '~/atomic/page/catalog/tagPage/tagPage.data';
import { tagFiltersSelector } from '~/atomic/page/catalog/tagPage/tagPage.selector';
import { Contest } from '~/atomic/page/contest/Contest';
import { catalogFilterActions } from '~/feature/catalog/filter/catalogFilter.slice';
import { paginationActions } from '~/feature/pagination/pagination.slice';
import { useAppDispatch, useAppSelector } from '~/store';

export const CONTEST_EVERYTHING_WILL_BE_FINE_TAG_SLUG = 'vse-budet-khorosho';

export const ContestEverythingWillBeFine = () => {
  const dispatch = useAppDispatch();
  const { books, isLoadBooks } = useAppSelector(tagFiltersSelector);

  const onLoadBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 100 }));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_EVERYTHING_WILL_BE_FINE_TAG_SLUG));
    dispatch(getBooks());
  };

  const onLoadSidebarBooks = () => {
    dispatch(paginationActions.setPageSize({ perPage: 6 }));
    dispatch(catalogFilterActions.setBookSorting(BookSortingEnum.Rand));
    dispatch(catalogFilterActions.setTagSlug(CONTEST_EVERYTHING_WILL_BE_FINE_TAG_SLUG));
    dispatch(getBooks());
  };

  return (
    <Contest
      bannerProps={{ bannerSrc: '/image/contest/everything-will-be-fine/banner.jpg' }}
      commentProps={{
        targetId: 3401,
        targetAuthorId: String(1493),
      }}
      contestBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks,
        description: 'Лонг-лист конкурса современных юмористических романов «Всё будет хорошо».',
      }}
      contestSidebarBooksProps={{
        books,
        isLoading: isLoadBooks,
        onLoadBooks: onLoadSidebarBooks,
      }}
      contestResults={{
        winnerBookSlugs: ['alisa-gordeeva-filfak', 'tatyana-donchenko-ya-ya-tebya-khudeyu'],
        secondPlace: ['zoyaanishkina-epilyatsiya-gauf'],
        thirdPlace: ['tatyana-milyakh-sibirskii-valenok--moskovskaya-kalosha'],
        shortList: ['elena-pronina-kurortnoe-pugalo'],
      }}
      descriptionProps={{
        content: (
          <>
            <p style={{
              textAlign: 'center',
              color: 'var(--green2-color)',
              fontSize: '18px',
              marginBottom: '24px',
            }}
            >
              Конкурс завершен
            </p>
            <p>
              «Bookriver» совместно с издательским домом «АСТ» проводит конкурс современных юмористических романов!
            </p>
            <p>
              Конкурс для всех, кто готов дарить своим читателям позитивные эмоции,
              рассказывать им о жизненных коллизиях и том, как из самой трудной
              ситуации можно выйти с улыбкой на губах и теплом в сердце.
            </p>
            <p>
              На конкурс принимаются работы в жанрах  современная проза + юмористический роман.
              Подробности вы можете посмотреть в разделе «Условия участия».
            </p>
            <h3>
              Сроки проведения конкурса
            </h3>
            <p>
              <b>Прием заявок:</b>
              {' '}
              до 3.03.2023г. включительно.
            </p>
            <p>
              <b>
                Работа жюри, формирование шорт-листа:
              </b>
              {' '}
              март-апрель 2023 года.
            </p>
            <p>
              <b>Оглашение победителей:</b>
              {' '}
              май 2023 года.
            </p>
            <p>
              <i>
                Сроки могут быть изменены по решению организаторов.
              </i>
            </p>
            <h3>
              Призы
            </h3>
            <p>
              <b>
                Первое место
                {' '}
                <i>
                  (первые места*)
                </i>
                {' '}
                :
              </b>
              {' '}
              заключение договора с АСТ, издание вашего романа.
            </p>
            <p>
              <b>
                Второе место:
              </b>
              {' '}
              30000 рублей.
            </p>
            <p>
              <b>
                Третье место:
              </b>
              {' '}
              15000 рублей.
            </p>
            <p>
              Для всех, попавших в шорт-лист,
              мы предоставим бесплатный месяц рекламы от портала на конкурсное произведение,
              после оглашения победителей и персональный баннер на главной странице.
            </p>
            <p>
              <i>
                * Издательство оставляет за собой право выбрать несколько победителей, заключив договор с каждым из них.
              </i>
            </p>
            <h3>
              Выбор победителя
            </h3>
            <p>
              <b>
                Лонг-лист
              </b>
              {' '}
              формируется на основании присланных участниками синопсисов.
            </p>
            <p>
              <b>
                Шорт-лист
              </b>
              {' '}
              формируется на основании литературно художественных достоинств текста,
              а так же — учитывается максимальное соответствие произведения тематике конкурса
              и читательский отклик (посещаемость, комментарии, библиотеки, покупки).
              В интересах автора вести читателя на страницу конкурсного романа,
              однако мы призываем не использовать накрутки — это будет строго отслеживаться,
              замеченные в нечестной игре будут сняты с конкурса.
            </p>
            <p>
              <b>
                Жюри:
              </b>
              {' '}
              команда Bookriver и редактор отдела «Жанры» издательства «АСТ», Екатерина Неволина.
            </p>
            <h3>
              Условия участия
            </h3>
            <p>
              Конкурсное произведение должно быть не старше мая 2022 года, не должно иметь издания
              в бумаге (ни самостоятельного, ни от какого-либо издательства),
              не должно распространяться бесплатно на постоянной основе. Наличие у произведения аннотации обязательно.
              Можно оформить только одну заявку от автора, на одну книгу.
            </p>
            <p>
              <b>
                Жанр:
              </b>
              {' '}
              Современная проза + юмористический роман.
              Допускается наличие третьего жанра — современный любовный роман
              — в этом случае любовная линия может быть основополагающей,
              но наличие юмора обязательно. Роман должен строиться на забавных жизненных ситуациях героев,
              их юмористическом взгляде на вещи даже в момент преодоления трудностей. Счастливый конец обязателен!
            </p>
            <p>
              Ваша книга должна быть написана в жанре «современность», без фант.допущений или мистики
              (исключая случайные стечения обстоятельств, которые герои могут воспринимать, как перст судьбы).
            </p>
            <p>
              <b>
                Объем:
              </b>
              {' '}
              от 360000 до 480 000 с пробелами, для завершенного произведения.
              Минимальный объем текста для подачи заявки — 100000 знаков для романа, имеющего статус  «в процессе».
            </p>
            <p>
              <b>
                Форма произведения:
              </b>
              {' '}
              роман.
            </p>
            <p>
              <b>
                Возрастной ценз:
              </b>
              {' '}
              16+
            </p>
            <p>
              <b>
                Статус произведения на момент подачи заявки:
              </b>
              {' '}
              «полностью» или
              «в процессе», с условием, что произведение будет выложено полностью до 3.03.2023г.
            </p>

            <p>
              Заявка отправляется на почту ads@bookriver.ru
            </p>
            <p>
              <b>
                Тема письма:
              </b>
              {' '}
              Все будет хорошо
            </p>
            <p>
              К заявке необходимо приложить синопсис (краткое описание сюжета, персонажей)
              в формате
              {' '}
              <b>.doc или .docx</b>
              {' '}
              Объем синопсиса до 10000 знаков с пробелами.
            </p>
            <p>
              Название документа с синопсисом указывайте в формате «Автор — Название романа — синопсис».
              Шапка синопсиса должна содержать:
            </p>
            <p>
              1. Имя/псевдоним автора
            </p>
            <p>
              2. Название произведения
            </p>
            <p>
              3. Ссылку на произведение на Bookriver.
            </p>

            <h3>
              Заявки без синопсиса будут отклоняться без рассмотрения!
              О том, что такое синопсис, вы можете прочитать тут
              {' '}
              <PostLink slugPost="sinopsis--shpargalka-dlya-avtora-3394">
                <a>
                  (ссылка на блог)
                </a>
              </PostLink>
            </h3>
          </>
        ),
      }}
    />
  );
};
